module.exports = "<hr>\n";